<div class="chat-window">
    <app-chat-selector fxFlex="nogrow">
    </app-chat-selector>
    <app-chat-messages fxFlex="auto" fxFlexFill></app-chat-messages>
</div>